var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-dialog',{attrs:{"show":_vm.show,"title":'Візити клієнта'},on:{"close":function($event){return _vm.$emit('close')}}},[_c('editable-table',{attrs:{"columns":_vm.columns,"items":_vm.customerVisits,"loading":_vm.loading},on:{"add":_vm.handleAdd,"edit":_vm.handleEdit,"delete":_vm.handleDelete}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }